import { createAction } from 'Lib/reduxUtils';

import type { BiometricsFlow } from 'Store/userBiometrics/types';

import {
  BIOMETRICS_BLOCKING_CONSENT_INIT,
  BIOMETRICS_IS_COMPLETED_SUCCESS,
  BIOMETRICS_IS_INITIALIZED,
} from './constants';

export const biometricsBlockingConsentInit = createAction(
  BIOMETRICS_BLOCKING_CONSENT_INIT,
  (flow: BiometricsFlow) => ({
    flow,
  })
);

export const completeBiometricsSuccess = createAction(BIOMETRICS_IS_COMPLETED_SUCCESS);

export const isBiometricsInitialized = createAction(
  BIOMETRICS_IS_INITIALIZED,
  (isInitialized: boolean) => ({
    isInitialized,
  })
);
